import Icon from '../components/Icon.vue'

Icon.register({"greater-than":{"width":384,"height":512,"paths":[{"d":"M365.5 209.8L59.2 67C43.2 59.5 24.1 66.5 16.6 82.5L3 111.6C-4.5 127.7 2.5 146.8 18.5 154.3L237 256.1 18.5 358C2.5 365.5-4.5 384.5 3 400.5L16.5 429.5C24 445.5 43 452.5 59.1 445L365.5 302.1A32-32 0 0 1 384 273.1V238.9C384 226.4 376.8 215.1 365.5 209.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/greater-than.js
// module id = ZQ8C
// module chunks = 0